:root {
  --color-pageBackground: var(--palette-gray600);
  --color-pageBackgroundModalActive: var(--palette-gray700);
  --color-pageBackgroundTopLeft: var(--palette-gray800);
  --color-pageBackgroundBottomRight: var(--palette-gray700);
  --color-pageBackgroundLineTop: var(--palette-purple300);
  --color-pageBackgroundLineMid: var(--palette-gray900);
  --color-pageBackgroundLineBottom: var(--palette-gray150);
  --color-pageText: var(--palette-gray100);
  --color-pageTextLight: var(--palette-gray200);
  --color-pageTextSubdued: var(--palette-gray400);
  --color-pageTextDark: var(--palette-gray100);
  --color-pageTextPositive: var(--palette-purple200);
  --color-pageTextLink: var(--palette-purple300);
  --color-pageTextLinkLight: var(--palette-purple300);

  --color-cardBackground: var(--palette-gray800);
  --color-cardBorder: var(--palette-purple300);
  --color-cardShadow: var(--palette-gray900);

  --color-tableBackground: var(--palette-gray800);
  --color-tableRowBackgroundAlternate: var(--color-tableBackground);
  --color-tableRowBackgroundHover: var(--palette-gray500);
  --color-tableText: var(--palette-gray150);
  --color-tableTextItemAdded: var(--color-tableText);
  --color-tableTextLight: var(--color-tableText);
  --color-tableTextSubdued: var(--palette-gray500);
  --color-tableTextSelected: var(--palette-gray800);
  --color-tableTextHover: var(--palette-gray400);
  --color-tableTextInactive: var(--palette-gray400);
  --color-tableHeaderText: var(--palette-gray200);
  --color-tableHeaderBackground: var(--palette-gray900);
  --color-tableBorder: var(--palette-gray600);
  --color-tableBorderSelected: var(--palette-purple400);
  --color-tableBorderHover: var(--palette-purple300);
  --color-tableBorderSeparator: var(--palette-gray400);
  --color-tableRowBackgroundHighlight: var(--palette-purple150);
  --color-tableRowBackgroundHighlightText: var(--palette-gray800);
  --color-tableRowHeaderBackground: var(--palette-gray700);
  --color-tableRowHeaderText: var(--palette-gray150);

  --color-numberPositive: var(--palette-green300);
  --color-numberNegative: var(--palette-red200);
  --color-numberNeutral: var(--palette-gray500);
  --color-budgetNumberNegative: var(--color-numberNegative);
  --color-budgetNumberZero: var(--color-tableTextSubdued);
  --color-budgetNumberNeutral: var(--color-tableText);
  --color-budgetNumberPositive: var(--color-budgetNumberNeutral);
  --color-templateNumberFunded: var(--color-numberPositive);
  --color-templateNumberUnderFunded: var(--palette-orange200);
  --color-toBudgetPositive: var(--color-numberPositive);
  --color-toBudgetZero: var(--color-numberPositive);
  --color-toBudgetNegative: var(--color-budgetNumberNegative);

  --color-sidebarBackground: var(--palette-gray900);
  --color-sidebarItemBackgroundPending: var(--palette-orange200);
  --color-sidebarItemBackgroundPositive: var(--palette-green400);
  --color-sidebarItemBackgroundFailed: var(--palette-red300);
  --color-sidebarItemAccentSelected: var(--palette-purple200);
  --color-sidebarItemBackgroundHover: var(--palette-gray700);
  --color-sidebarItemBackgroundSelected: color-mix(
    in srgb,
    var(--color-sidebarItemAccentSelected) 35%,
    transparent
  );
  --color-sidebarItemText: var(--palette-gray100);
  --color-sidebarItemTextUpdated: var(--color-sidebarItemText);
  --color-sidebarItemTextSelected: var(--palette-purple200);
  --color-sidebarBudgetName: var(--palette-gray300);
  --color-sidebarHeaderText: var(--palette-gray100);
  --color-sidebarTextSubdued: var(--palette-gray300);
  --color-sidebarTextMuted: var(--palette-gray500);
  --color-sidebarTextPositive: var(--color-sidebarItemBackgroundPositive);
  --color-sidebarTextFailed: var(--color-sidebarItemBackgroundFailed);
  --color-sidebarBackgroundFailedSubtle: color-mix(
    in srgb,
    var(--color-sidebarItemBackgroundFailed) 16%,
    transparent
  );
  --color-sidebarBorder: var(--color-sidebarItemBackgroundHover);
  --color-sidebarControlBackground: var(--color-sidebarItemBackgroundHover);
  --color-sidebarBrand: var(--color-sidebarItemAccentSelected);

  --color-settingsCardBackground: var(--color-tableBackground);
  --color-settingsCardBorder: var(--color-tableBorder);
  --color-settingsCardText: var(--color-tableText);
  --color-settingsCardTextSubdued: var(--palette-gray200);
  --color-settingsNavItemText: var(--color-pageText);
  --color-settingsNavItemBackgroundHover: color-mix(
    in srgb,
    var(--color-settingsNavItemText) 8%,
    transparent
  );
  --color-settingsNavItemAccentSelected: var(--palette-purple200);
  --color-settingsNavItemTextSelected: var(
    --color-settingsNavItemAccentSelected
  );
  --color-settingsNavItemBackgroundSelected: color-mix(
    in srgb,
    var(--color-settingsNavItemAccentSelected) 22%,
    transparent
  );

  --color-menuBackground: var(--palette-gray700);
  --color-menuItemBackground: var(--palette-gray200);
  --color-menuItemBackgroundHover: var(--palette-gray500);
  --color-menuItemText: var(--palette-gray100);
  --color-menuItemTextHover: var(--palette-gray50);
  --color-menuItemTextSelected: var(--palette-purple400);
  --color-menuItemTextHeader: var(--palette-purple200);
  --color-menuBorder: var(--palette-gray800);
  --color-menuBorderHover: var(--palette-purple300);
  --color-menuKeybindingText: var(--palette-purple200);
  --color-menuAutoCompleteBackground: var(--palette-gray600);
  --color-menuAutoCompleteBackgroundHover: var(--palette-gray500);
  --color-menuAutoCompleteText: var(--palette-gray100);
  --color-menuAutoCompleteTextHover: var(--palette-green400);
  --color-menuAutoCompleteTextHeader: var(--palette-purple200);
  --color-menuAutoCompleteItemTextHover: var(--palette-gray50);
  --color-menuAutoCompleteItemText: var(--color-menuItemText);
  --color-modalBackground: var(--palette-gray700);
  --color-modalBorder: var(--palette-gray200);
  --color-mobileHeaderBackground: var(--palette-gray900);
  --color-mobileHeaderText: var(--palette-purple200);
  --color-mobileHeaderTextSubdued: var(--palette-gray200);
  --color-mobileHeaderTextHover: rgba(200, 200, 200, 0.15);
  --color-mobilePageBackground: var(--palette-gray900);
  --color-mobileNavBackground: var(--palette-gray600);
  --color-mobileNavItem: var(--palette-gray150);
  --color-mobileNavItemSelected: var(--palette-purple200);
  --color-mobileAccountShadow: var(--color-cardShadow);
  --color-mobileAccountText: var(--palette-blue800);
  --color-mobileTransactionSelected: var(--palette-purple300);

  --color-mobileViewTheme: var(--color-mobileHeaderBackground);
  --color-mobileConfigServerViewTheme: var(--palette-purple500);

  --color-markdownNormal: var(--palette-purple700);
  --color-markdownDark: var(--palette-purple500);
  --color-markdownLight: var(--palette-purple800);

  --color-buttonMenuText: var(--palette-gray200);
  --color-buttonMenuTextHover: var(--color-buttonMenuText);
  --color-buttonMenuBackground: var(--palette-gray700);
  --color-buttonMenuBackgroundHover: rgba(200, 200, 200, 0.25);
  --color-buttonMenuBorder: var(--palette-gray500);
  --color-buttonMenuSelectedText: var(--palette-green800);
  --color-buttonMenuSelectedTextHover: var(--palette-orange800);
  --color-buttonMenuSelectedBackground: var(--palette-orange200);
  --color-buttonMenuSelectedBackgroundHover: var(--palette-gray300);
  --color-buttonMenuSelectedBorder: var(--color-buttonMenuSelectedBackground);

  --color-buttonPrimaryText: var(--palette-white);
  --color-buttonPrimaryTextHover: var(--color-buttonPrimaryText);
  --color-buttonPrimaryBackground: var(--palette-purple300);
  --color-buttonPrimaryBackgroundHover: var(--color-buttonPrimaryBackground);
  --color-buttonPrimaryBorder: var(--color-buttonPrimaryBackground);
  --color-buttonPrimaryShadow: rgba(0, 0, 0, 0.6);
  --color-buttonPrimaryDisabledText: var(--palette-gray400);
  --color-buttonPrimaryDisabledBackground: var(--palette-gray700);
  --color-buttonPrimaryDisabledBorder: var(
    --color-buttonPrimaryDisabledBackground
  );

  --color-buttonNormalText: var(--palette-gray150);
  --color-buttonNormalTextHover: var(--palette-gray150);
  --color-buttonNormalBackground: var(--palette-gray600);
  --color-buttonNormalBackgroundHover: var(--palette-gray400);
  --color-buttonNormalBorder: var(--palette-gray300);
  --color-buttonNormalShadow: rgba(0, 0, 0, 0.4);
  --color-buttonNormalSelectedText: var(--palette-white);
  --color-buttonNormalSelectedBackground: var(--palette-purple500);
  --color-buttonNormalDisabledText: var(--palette-gray400);
  --color-buttonNormalDisabledBackground: var(--palette-gray700);
  --color-buttonNormalDisabledBorder: var(--palette-gray500);

  --color-calendarText: var(--palette-gray50);
  --color-calendarBackground: var(--palette-gray700);
  --color-calendarItemText: var(--palette-gray150);
  --color-calendarItemBackground: var(--palette-gray500);
  --color-calendarSelectedBackground: var(
    --color-buttonNormalSelectedBackground
  );
  --color-datePickerRangeBackground: var(--palette-purple600);

  --color-buttonBareText: var(--color-pageText);
  --color-buttonBareTextHover: var(--color-pageText);
  --color-buttonBareDisabledText: var(--color-pageTextSubdued);
  --color-buttonBareBackground: transparent;
  --color-buttonBareDisabledBackground: var(--color-buttonBareBackground);
  --color-buttonBareBackgroundHover: rgba(200, 200, 200, 0.3);
  --color-buttonBareBackgroundActive: rgba(200, 200, 200, 0.5);

  --color-noticeBackground: var(--palette-green600);
  --color-noticeBackgroundLight: var(--palette-green900);
  --color-noticeBackgroundDark: var(--palette-green400);
  --color-noticeText: var(--palette-green300);
  --color-noticeTextLight: var(--palette-green400);
  --color-noticeTextDark: var(--palette-green150);
  --color-noticeTextMenu: var(--palette-green400);
  --color-noticeTextMenuHover: var(--palette-green700);
  --color-noticeBorder: var(--palette-green800);
  --color-warningBackground: var(--palette-orange800);
  --color-warningText: var(--palette-orange200);
  --color-warningTextLight: var(--palette-orange500);
  --color-warningTextDark: var(--palette-orange100);
  --color-warningBorder: var(--palette-orange500);
  --color-errorBackground: var(--palette-red800);
  --color-errorText: var(--palette-red200);
  --color-errorTextDark: var(--palette-red150);
  --color-errorTextDarker: var(--color-errorTextDark);
  --color-errorTextMenu: var(--palette-red200);
  --color-errorBorder: var(--palette-red500);
  --color-upcomingBackground: var(--palette-purple800);
  --color-upcomingText: var(--palette-purple200);
  --color-upcomingBorder: var(--color-tableBorder);

  --color-formLabelText: var(--palette-purple150);
  --color-formLabelBackground: var(--palette-blue900);
  --color-formInputBackground: var(--palette-gray800);
  --color-formInputBackgroundSelected: var(--palette-gray700);
  --color-formInputBackgroundSelection: var(--palette-purple400);
  --color-formInputBorder: var(--palette-gray600);
  --color-formInputTextReadOnlySelection: var(--palette-gray800);
  --color-formInputBorderSelected: var(--palette-purple300);
  --color-formInputText: var(--palette-gray150);
  --color-formInputTextSelected: var(--palette-black);
  --color-formInputTextPlaceholder: var(--palette-gray150);
  --color-formInputTextPlaceholderSelected: var(--palette-gray100);
  --color-formInputTextSelection: var(--palette-gray800);
  --color-formInputShadowSelected: var(--palette-purple400);
  --color-formInputTextHighlight: var(--palette-purple200);
  --color-checkboxText: var(--color-tableText);
  --color-checkboxBackgroundSelected: var(--palette-purple300);
  --color-checkboxBorderSelected: var(--palette-purple300);
  --color-checkboxShadowSelected: var(--palette-purple500);
  --color-checkboxToggleBackground: var(--palette-gray400);
  --color-checkboxToggleBackgroundSelected: var(--palette-purple300);
  --color-checkboxToggleDisabled: var(--palette-gray700);

  --color-pillBackground: var(--palette-gray500);
  --color-pillBackgroundLight: var(--palette-gray900);
  --color-pillText: var(--palette-gray200);
  --color-pillTextHighlighted: var(--palette-purple200);
  --color-pillBorder: var(--palette-gray500);
  --color-pillBorderDark: var(--color-pillBorder);
  --color-pillBackgroundSelected: var(--palette-purple600);
  --color-pillTextSelected: var(--palette-gray150);
  --color-pillBorderSelected: var(--palette-purple300);
  --color-pillTextSubdued: var(--palette-gray500);

  --color-reportsRed: var(--palette-red300);
  --color-reportsBlue: var(--palette-blue400);
  --color-reportsGreen: var(--palette-green400);
  --color-reportsGray: var(--palette-gray400);
  --color-reportsLabel: var(--color-pageText);
  --color-reportsInnerLabel: var(--palette-navy800);
  --color-reportsNumberPositive: var(--color-numberPositive);
  --color-reportsNumberNegative: var(--color-numberNegative);
  --color-reportsNumberNeutral: var(--color-numberNeutral);
  --color-reportsChartFill: var(--color-reportsNumberPositive);

  --color-noteTagBackground: var(--palette-purple800);
  --color-noteTagBackgroundHover: var(--palette-purple600);
  --color-noteTagDefault: var(--palette-purple700);
  --color-noteTagText: var(--palette-purple100);

  --color-budgetOtherMonth: var(--palette-gray700);
  --color-budgetCurrentMonth: var(--color-tableBackground);
  --color-budgetHeaderOtherMonth: var(--palette-gray800);
  --color-budgetHeaderCurrentMonth: var(--color-tableHeaderBackground);

  --color-floatingActionBarBackground: var(--palette-gray900);
  --color-floatingActionBarBorder: var(--palette-purple300);
  --color-floatingActionBarText: var(--palette-purple200);

  --color-tooltipText: var(--palette-gray100);
  --color-tooltipBackground: var(--palette-gray800);
  --color-tooltipBorder: var(--palette-gray600);

  --color-calendarCellBackground: var(--palette-navy900);

  --color-overlayBackground: rgba(0, 0, 0, 0.3);

  --color-chartQual1: var(--palette-chartQual1);
  --color-chartQual2: var(--palette-chartQual2);
  --color-chartQual3: var(--palette-chartQual3);
  --color-chartQual4: var(--palette-chartQual4);
  --color-chartQual5: var(--palette-chartQual5);
  --color-chartQual6: var(--palette-chartQual6);
  --color-chartQual7: var(--palette-chartQual7);
  --color-chartQual8: var(--palette-chartQual8);
  --color-chartQual9: var(--palette-chartQual9);
}
